import { render } from "./DentalPlan.vue?vue&type=template&id=3d1a0c68"
import script from "./DentalPlan.vue?vue&type=script&lang=js"
export * from "./DentalPlan.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__